/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Stage_CapabilitiesInputs */

const en_byoa_stage_capabilities = /** @type {(inputs: Byoa_Stage_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available for planning, chat, summaries and review. Image and tool support depend on the selected model.`)
};

const id_byoa_stage_capabilities = /** @type {(inputs: Byoa_Stage_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dipilih untuk rencana, chat, ringkasan, dan review. Dukungan gambar dan alat bergantung pada model yang dipilih.`)
};

/**
* | output |
* | --- |
* | "Available for planning, chat, summaries and review. Image and tool support depend on the selected model." |
*
* @param {Byoa_Stage_CapabilitiesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_stage_capabilities = /** @type {((inputs?: Byoa_Stage_CapabilitiesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Stage_CapabilitiesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_stage_capabilities(inputs)
	return en_byoa_stage_capabilities(inputs)
});